import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { AuthService } from '../../services/auth.service';

@Component({
  selector: 'app-reset-password',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './reset-password.component.html',
  styleUrl: './reset-password.component.less'
})
export class ResetPasswordComponent implements OnInit {
  newPassword: string = '';
  retypePassword: string = '';
  showPassword: boolean = false;
  passwordError: string = '';
  resetToken: string = '';
  userId: string = '';
  isLinkValid: boolean = false;
  isLoading: boolean = true;
  serverError: string = '';
  showSuccessModal: boolean = false;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private http: HttpClient,
    private authService: AuthService
  ) {}

  ngOnInit(): void {
    this.route.params.subscribe(params => {
      const token = params['id'];
      this.resetToken = token;

      this.authService.verifyResetToken(token).subscribe({
        next: (res: any) => {
          this.userId = res.user_id;
          this.isLinkValid = true;
          this.isLoading = false;
        },
        error: (err) => {
          this.isLinkValid = false;
          this.isLoading = false;
          this.serverError = err?.error?.message || 'This reset link is invalid or has expired.';
        }
      });
    });
  }

  togglePasswordVisibility() {
    this.showPassword = !this.showPassword;
  }

  validatePassword(password: string): string | null {
    const minLength = /^.{8,}$/;
    const hasUpperCase = /[A-Z]/;
    const hasSpecialChar = /[!@#$%^&*(),.?":{}|<>]/;

    if (!minLength.test(password)) {
      return 'Password must be at least 8 characters long.';
    }
    if (!hasUpperCase.test(password)) {
      return 'Password must include at least one uppercase letter.';
    }
    if (!hasSpecialChar.test(password)) {
      return 'Password must include at least one special character.';
    }

    return null;
  }

  resetPassword() {
    this.passwordError = '';

    const validationMessage = this.validatePassword(this.newPassword);
    if (validationMessage) {
      this.passwordError = validationMessage;
      return;
    }

    if (this.newPassword !== this.retypePassword) {
      this.passwordError = 'Passwords do not match';
      return;
    }

    this.authService.resetPassword(this.resetToken, this.userId, this.newPassword).subscribe({
      next: () => {
        this.showSuccessModal = true; // ✅ Wait for user to close modal
      },
      error: (err) => {
        console.error(err);
        this.passwordError = err?.error?.message || 'Something went wrong.';
      }
    });
  }

  closeModal() {
    this.showSuccessModal = false;
    this.router.navigate(['/auth']); // ✅ Navigate only after user confirms
  }
}
